<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-heading">
      <div class="pcontainer">
        <div class="heading-content">
          <h1>CONNECTION</h1>
        </div>
      </div>
    </div>

    <div class="container" id="page">
      <!-- 内容 -->
      <div class="contact" id="lxdz">
        <div class="main">
          <div class="contactBox">
            <h5 class="title fadeInUp wow animated" data-wow-delay="0.3s">
              Contact Address
            </h5>
            <div class="contactaddress">
              <div
                class="contactleft fadeInRight wow animated hidden-xs"
                data-wow-delay="0.6s"
              ></div>
              <div
                class="contactright fadeInLeft wow animated"
                data-wow-delay="0.6s"
              >
                <ul>
                  <li>
                    <h6>China-Shanghai</h6>
                    <div class="contactText">
                      <div class="addresscontact">
                        <div class="item">
                          <div class="img">
                            <img v-lazy="lxhy1" alt="Lazy-loaded Image" />
                            <p>Hua Yin Group</p>
                          </div>
                          <div class="communication">
                            <p class="site">
                              No. 26, Lane 168, Daduhe Road, Putuo, Shanghai,
                              China
                            </p>
                            <p class="phone">86-21-32501378</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <h6>China-Nantong</h6>
                    <div class="contactText">
                      <div class="top">
                        <p class="active">Huanyin</p>
                        <p class="">Guosheng</p>
                      </div>
                      <div class="addresscontact">
                        <div class="change">
                          <div class="item">
                            <div class="img">
                              <img v-lazy="lxhy2" alt="Lazy-loaded Image" />
                              <p>
                                Hua Yin Steel Structure Engineering (Jiangsu)
                                Co., Ltd
                              </p>
                            </div>
                            <div class="communication">
                              <p class="site">
                                No. 889, Riyuetan Road, Hai'an, Nantong,
                                Jiangsu, China
                              </p>
                              <p class="phone">86-513-88650056</p>
                            </div>
                          </div>
                          <div class="item">
                            <div class="img">
                              <img v-lazy="lxhy3" alt="Lazy-loaded Image" />
                              <p>Guosheng New Energy (Hai'an) Co., Ltd.</p>
                            </div>
                            <div class="communication">
                              <p class="site">
                                No. 889, Riyuetan Road, Hai'an, Nantong,
                                Jiangsu, China
                              </p>
                              <p class="phone">86-513-88650056</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <h6>China-Kunshan</h6>
                    <div class="contactText">
                      <div class="addresscontact">
                        <div class="item">
                          <div class="img">
                            <img v-lazy="lxhy4" alt="Lazy-loaded Image" />
                            <p>
                              Hua Yin Steel Structure Engineering (Kunshan) Co.,
                              Ltd.
                            </p>
                          </div>
                          <div class="communication">
                            <p class="site">
                              No. 1225, Tongfeng East Road, Kunshan, Jiangsu,
                              China
                            </p>
                            <p class="phone">0512-57597986</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <h6>China-Taiwan</h6>
                    <div class="contactText">
                      <div class="addresscontact">
                        <div class="item">
                          <div class="img">
                            <img v-lazy="lxhy5" alt="Lazy-loaded Image" />
                            <p>Huayin Engineering Co., Ltd.</p>
                          </div>
                          <div class="communication">
                            <p class="site">
                              5C14, Xinyi Road, Taipei, Taiwan
                            </p>
                            <p class="phone">886-2-27904868</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <h6>Mexico</h6>
                    <div class="contactText">
                      <div class="addresscontact">
                        <div class="item">
                          <div class="img">
                            <img v-lazy="lxhy6" alt="Lazy-loaded Image" />
                            <p>North American Factory</p>
                          </div>
                          <div class="communication">
                            <p class="site">
                              Privada Georgina #121 Privadas del Canadá, sector Toronto Escobedo, N.L. CP:64700
                            </p>
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contact" id="rszp">
        <div class="main">
          <div class="contactBox">
            <h5 class="title fadeInUp wow animated" data-wow-delay="0.3s">
              HR Recruitment
            </h5>
            <h4>HR：Ms Liu&nbsp;&nbsp;Telephone：0513-81807281</h4>
            <h4>
              Company Address：No. 889, Riyuetan Road, Hai'an, Nantong, Jiangsu,
              China
            </h4>
            <div class="ewb-recruit-box">
              <ul class="ewb-recruit-list">
                <li
                  class="ewb-recruit-node clearfix"
                  v-for="(item, index) in rszpenList"
                  :key="index"
                >
                  <div class="ewb-recruit-date">
                    <span class="ewb-day">{{ item.pDay }}</span>
                    <span class="ewb-yearmonth">{{ item.pMouth }}</span>
                    <span class="ewb-yearmonth">{{ item.pYear }}</span>
                  </div>
                  <div class="ewb-recruit-info">
                    <p class="ewb-recruit-name">{{ item.post }}</p>
                    <div class="ewb-recruit-remind">
                      <span>Number：{{ item.pNumber }}</span>
                      <span>Salary：{{ item.pMoney }}</span>
                    </div>
                    <div class="row">
                      <div class="col-md-10">
                        <span>Requirements:</span>
                        <p
                          class="ewb-recruit-require"
                          v-html="item.pRequire"
                        ></p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import $ from 'jquery'
export default {
  data() {
    return {
      lxhy1: require('@/components/img/lxhy/sh.jpg'),
      lxhy2: require('@/components/img/lxhy/js.jpg'),
      lxhy3: require('@/components/img/lxhy/ha.png'),
      lxhy4: require('@/components/img/lxhy/ks.jpg'),
      lxhy5: require('@/components/img/lxhy/tw.jpg'),
      lxhy6: require('@/components/img/lxhy/mxg.png'),
    }
  },
  async mounted() {
    // 切换
    $('.contactright .addresscontact .change .item')
      .eq(0)
      .show()
      .siblings()
      .hide()
    $('.contact .contactright .top p').click(function () {
      var i = $(this).index()
      $(this).addClass('active').siblings().removeClass('active')
      $('.contactright .addresscontact .change .item')
        .eq(i)
        .show()
        .siblings()
        .hide()
    })
    // 下拉
    $('.contact .contactright li').eq(0).children('h6').addClass('active')
    $('.contact .contactright li').eq(0).children('.contactText').show()
    $('.contact .contactright li h6').click(function () {
      $(this).toggleClass('active')
      $(this).siblings('.contactText').slideToggle()
      $(this).parents('li').siblings().children('.contactText').slideUp()
      $(this).parents('li').siblings().children('h6').removeClass('active')
    })
    await this.$store.dispatch('rszpenList')
  },
  computed: {
    ...mapState({
      rszpenList: (state) => state.rszp.rszpenList,
    }),
  },
}
</script>

<style scoped>
#lxdz,
#rszp {
  margin-top: -83px;
  padding-top: 83px;
}
/* 联系方式 */
.contact {
  padding: 30px 0;
}

.contact .contactBox .title {
  font-size: 30px;
  line-height: 1;
  font-weight: 400;
  color: #000000;
  margin: 35px 0;
}

.contact .contactaddress {
  width: 100%;
  height: 760px;
  background: url(@/components/img/lxhy/121.jpg) no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.contact .contactaddress .contactleft {
  /* width: 68.75%; */
  width: 55%;
  height: 100%;
  display: flex;
  align-items: center;
  background: url(@/components/img/lxhy/NB-Map.png);
  background-size: 100% 100%;
}

/* .contact .contactaddress .contactleft .contactinfo {
    width: 55%;
    height: 100%;
    margin: auto;
} */

.contact .contactaddress .contactright {
  /* width: 31.25%; */
  width: 45%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
}
@media screen and (max-width: 768px) {
  .contact .contactaddress .contactright {
    width: 100% !important;
  }
}
.contact .contactright {
  padding: 30px;
}

.contact .contactright li .contactText {
  display: none;
}

.contact .contactright li h6 {
  font-size: 20px;
  line-height: 1;
  font-weight: 400;
  color: #fff;
  padding: 16px 0;
  cursor: pointer;
  background: url(@/components/img/lxhy/icon71.png) no-repeat center right 15px;
}

.contact .contactright li h6.active {
  background: url(@/components/img/lxhy/icon72.png) no-repeat center right 15px;
}

.contact .contactright li {
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.contact .contactright li::after {
  content: '';
  position: absolute;
  bottom: -1px;
  right: 0;
  width: 60px;
  height: 1px;
  background: #fff;
}

.contact .contactright ul {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
}

.contact .contactright ul::after {
  content: '';
  position: absolute;
  top: -1px;
  right: 0;
  width: 60px;
  height: 1px;
  background: #fff;
}

.contact .contactright .top p {
  font-size: 14px;
  color: #fff;
  line-height: 1;
  padding: 7px 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 24px;
  display: inline-block;
  margin-right: 20px;
  cursor: pointer;
  margin-bottom: 20px;
}

.contact .contactright .top p.active {
  background: #015db2;
  border: 1px solid #015db2;
}

.contact .contactright .addresscontact .item .img {
  width: 267px;
  position: relative;
  display: inline-block;
  overflow: hidden;
}

.contact .contactright .addresscontact .item .img img {
  width: 100%;
  max-width: 100%;
  transition: All 0.6s ease;
  -webkit-transition: All 0.6s ease;
  -moz-transition: All 0.6s ease;
  -o-transition: All 0.6s ease;
}

.contact .contactright .addresscontact .item:hover .img img {
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);
}

.contact .contactright .addresscontact .item .img p {
  font-size: 16px;
  line-height: 30px;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  padding: 5px 20px;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 5;
  width: 100%;
}

.contact .contactright .addresscontact .item .communication {
  padding: 15px 0;
}

.contact .contactright .addresscontact .item .communication p {
  padding-left: 45px;
  font-size: 16px;
  line-height: 30px;
  color: #fff;
  position: relative;
}

.contact .contactright .addresscontact .item .communication p.site {
  background: url(@/components/img/lxhy/icon73.png) no-repeat top 7px left;
}

.contact .contactright .addresscontact .item .communication p.phone {
  background: url(@/components/img/lxhy/icon74.png) no-repeat top 7px left;
}

.contact .contactright .addresscontact .item .communication p.email {
  background: url(@/components/img/lxhy/icon75.png) no-repeat top 8px left;
}

.contact .contactright .addresscontact .item .communication p.site::after {
  content: 'A:';
  position: absolute;
  left: 30px;
  top: 0;
  font-size: 14px;
  line-height: 30px;
  color: #fff;
}

.contact .contactright .addresscontact .item .communication p.phone::after {
  content: 'T:';
  position: absolute;
  left: 30px;
  top: 0;
  font-size: 14px;
  line-height: 30px;
  color: #fff;
}

.contact .contactright .addresscontact .item .communication p.email::after {
  content: 'E:';
  position: absolute;
  left: 30px;
  top: 0;
  font-size: 14px;
  line-height: 30px;
  color: #fff;
}

.contact #allmap {
  width: 100%;
  height: 100%;
  display: inline-block;
  border-radius: 50%;
  position: relative;
}

.contact #allmap .location:nth-of-type(1) {
  top: 170px;
  right: 245px;
}

.contact #allmap .location:nth-of-type(2) {
  top: 155px;
  right: 260px;
}

.contact #allmap .location:nth-of-type(3) {
  top: 175px;
  left: 170px;
}

.contact #allmap .location:nth-of-type(4) {
  top: 179px;
  left: 150px;
}

.contact #allmap .location:nth-of-type(5) {
  top: 240px;
  left: 135px;
}

.contact #allmap .location:nth-of-type(6) {
  top: 230px;
  left: 90px;
}

.contact #allmap .location {
  position: absolute;
  top: 0;
  z-index: 88;
  width: 50px;
  height: 50px;
  overflow: hidden;
}

.contact #allmap .location .dot-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  background-color: #015db2;
  border: 2px solid #fff;
  border-radius: 50%;
}

.contact #allmap .location > div {
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  animation: amplificationAn 3s linear infinite;
  background-color: transparent;
  border: 2px solid #fff;
  border-radius: 50%;
}

.contact #allmap .location > div > div {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 0;
  height: 0;
  animation: amplificationAn 3s 1.2s linear infinite;
  background-color: transparent;
  border: 2px solid #fff;
  border-radius: 50%;
}

@keyframes amplificationAn {
  to {
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
  }
}

@media screen and (min-width: 1300px) {
  .container {
    width: 1260px;
  }
}
@media screen and (min-width: 1400px) {
  .container {
    width: 1360px;
  }
}
/* header */
.page-heading {
  background-image: url(@/components/img/lxhy/top4.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  text-align: center;
}

.page-heading .heading-content h1 {
  font-size: 32px;
  text-transform: uppercase;
  color: #fff;
  letter-spacing: 1px;
  background-color: rgba(5, 5, 5, 0.9);
  display: inline-block;
  margin-bottom: 0;
  margin-top: 220px;
  padding: 20px 60px;
}

.page-heading .heading-content em {
  font-style: normal;
  font-weight: 200;
}
/* 人事招聘 */
.ewb-recruit-list {
  padding: 26px 0 70px 0;
}

.ewb-recruit-node {
  min-height: 164px;
}

.ewb-recruit-date {
  float: left;
  margin-top: 26px;
  width: 7%;
  height: 112px;
  text-align: center;
  color: #fff;
  background-color: #a5ccf8;
}

.ewb-day {
  display: block;
  padding-top: 2px;
  line-height: 54px;
  font-size: 36px;
}

.ewb-yearmonth {
  display: block;
  line-height: 20px;
}

.ewb-recruit-info {
  float: left;
  margin-left: 2.5%;
  padding-top: 17px;
  width: 90%;
}

.ewb-recruit-name {
  display: block;
  line-height: 36px;
  font-size: 18px;
  color: #333;
}

.ewb-recruit-name:hover {
  color: #3373cb;
}

.ewb-recruit-remind {
  line-height: 32px;
}

.ewb-recruit-remind span {
  display: inline-block;
  margin-left: 30px;
}

.ewb-recruit-remind span:first-child {
  margin-left: 0;
}

.ewb-recruit-require {
  margin-top: 4px;
  line-height: 28px;
  color: #999;
  text-align: justify;
  text-justify: inter-ideograph;
}

.ewb-recruit-img {
  float: right;
  margin-top: 26px;
  width: 246px;
}
@media (max-width: 1199px) {
  .ewb-recruit-list {
    padding: 20px 0;
  }
  .ewb-recruit-date {
    width: 9%;
  }
  .ewb-day {
    font-size: 30px;
  }
  .ewb-recruit-img {
    width: 170px;
  }
  .ewb-recruit-info {
    width: 63%;
  }
  .ewb-recruit-name {
    line-height: 32px;
    font-size: 16px;
  }
  .ewb-recruit-remind {
    line-height: 28px;
  }
  .ewb-recruit-require {
    margin-top: 0;
    line-height: 24px;
  }
  .ewb-recruit-box {
    margin-top: 30px;
  }
}

@media (max-width: 767px) {
  .ewb-recruit-box {
    margin-top: 20px;
    padding-bottom: 30px;
  }
  .ewb-recruit-list {
    padding: 0 5px 20px 5px;
  }
  .ewb-recruit-node {
    min-height: auto;
    padding: 10px 0;
  }
  .ewb-recruit-date {
    margin-top: 8px;
    width: auto;
    height: 36px;
    padding: 0 10px;
  }
  .ewb-recruit-date span {
    float: right;
    font-size: 16px;
    padding: 0;
    margin: 0 3px;
    height: 36px;
    line-height: 36px;
  }
  .ewb-recruit-info {
    padding-top: 4px;
    margin-left: 0;
    width: 100%;
  }
  .ewb-recruit-name {
    line-height: 30px;
    font-size: 14px;
  }
  .ewb-recruit-remind,
  .ewb-recruit-require {
    line-height: 22px;
    font-size: 12px;
  }
  .ewb-recruit-remind span {
    margin-left: 0;
    margin-right: 5px;
  }
}
@media (max-width: 768px) {
  .contact .contactright li h6 {
    font-size: 16px;
    line-height: 1;
    font-weight: 300;
    color: #fff;
    padding: 10px 0;
    cursor: pointer;
    background: url(@/components/img/lxhy/icon71.png) no-repeat center right
      15px;
  }
  .contact .contactright .addresscontact .item .communication {
    padding: 10px 0;
  }

  .contact .contactright .addresscontact .item .communication p {
    padding-left: 45px;
    font-size: 12px;
    line-height: 30px;
    color: #fff;
    position: relative;
  }
  .contact .contactright .addresscontact .item .img p {
    font-size: 14px;
  }
}
@media screen and (min-width: 2000px) {
  .container {
    width: 1960px;
  }
  .contact .contactaddress {
    height: 850px;
  }
  .contact .contactright li h6 {
    font-size: 25px;
  }
  .contact .contactright .addresscontact .item .img {
    width: 400px;
  }
  .contact .contactright .addresscontact .item .communication p {
    font-size: 20px;
  }
  .contact .contactright .addresscontact .item .img p {
    font-size: 18px;
  }
  .contactBox h4 {
    font-size: 25px;
  }
  .ewb-recruit-name {
    font-size: 20px;
  }
  .ewb-recruit-remind {
    font-size: 18px;
  }
  .ewb-recruit-info .col-md-10 span {
    font-size: 18px;
  }
  .ewb-recruit-require {
    font-size: 18px;
  }
  .page-heading .heading-content h1 {
    font-size: 40px;
  }
  .zzitem li a {
    margin: 0 50px;
    font-size: 25px;
  }
}
</style>
